<template>
    <b-input-group size="lg">
        <!-- PLACE SEARCH -->
        <vue-typeahead-bootstrap
            class="test1"
            v-model="placeQuery"
            :data="place_search_suggestion_list"
            placeholder="plumbers, delivery, takeout..."
            :showOnFocus=true
            prepend="Find"
            :serializer="item => item.mainText"
            size="lg"
            @input="lookupPlaceQuery"
            :maxMatches=20
            :disableSort=true
            :showAllResults=true
            @hit="onPlaceSelected"
        >
            <template slot="suggestion" slot-scope="{ data, htmlText }">
                <PlaceSlot :data="data" :htmlText="htmlText" />
            </template>
        </vue-typeahead-bootstrap>
        
        <!-- LOCATION SEARCH -->
        <vue-typeahead-bootstrap
            class="test1"
            v-model="locationQuery"
            :data="location_search_suggestion_list"
            placeholder="Makati City, NCR"
            :showOnFocus=true
            prepend="Near"
            :serializer="item => item.mainText"
            size="lg"
            @input="lookupLocationQuery"
            :maxMatches=20
            :disableSort=true
            :showAllResults=true
            @hit="onLocationSelected"
        >
            <template slot="suggestion" slot-scope="{ data, htmlText }">
                <LocationSlot :data="data" :htmlText="htmlText" />
            </template>
        </vue-typeahead-bootstrap>


        <b-input-group-prepend >
            <span class="input-group-text search">
                <b-icon
                    v-if="!search_result_retrieving" 
                    icon="search" 
                    @click="searchClicked">
                </b-icon>
                <b-spinner v-else

                ></b-spinner>
            </span>
        </b-input-group-prepend>
    </b-input-group>
</template>

<style scoped>
.search {
    color: white;
    background-color:#FE5F75;
    border-width: 0px;
    border-color: transparent;
}
</style>

<script> 
import PlaceSlot from './PlaceSlot'
import LocationSlot from './LocationSlot'
import _ from 'lodash';

export default {
    components: {
        PlaceSlot,
        LocationSlot
    },
    props: {
        reloadPage: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            defaultPlaceSearchResults: [
                {
                    id: '0',
                    mainText: 'Restaurants',
                    imgLink: 'https://img.icons8.com/ios/452/restaurant.png',
                    subText: '',
                    type: 'TAG'
                },
                {
                    id: '1',
                    mainText: 'Delivery',
                    imgLink: 'https://cdn1.iconfinder.com/data/icons/logistics-transportation-vehicles/202/logistic-shipping-vehicles-002-512.png',
                    subText: '',
                    type: 'TAG'
                },
                {
                    id: '2',
                    mainText: 'Takeout',
                    imgLink: 'https://static.thenounproject.com/png/646465-200.png',
                    subText: '',
                    type: 'TAG'
                },
                {
                    id: '3',
                    mainText: 'Accountants',
                    imgLink: 'https://img.icons8.com/pastel-glyph/2x/calculator.png',
                    subText: '',
                    type: 'TAG'
                },
                {
                    id: '4',
                    mainText: 'Plumbers',
                    imgLink: 'https://www.pngrepo.com/download/247357/faucet.png',
                    subText: '',
                    type: 'TAG'
                },
                {
                    id: '5',
                    mainText: 'Auto Repair',
                    imgLink: 'http://simpleicon.com/wp-content/uploads/wrench.png',
                    subText: '',
                    type: 'TAG'
                }
            ],
            placeQuery: "",
            locationQuery: "",
            placeSelected: null,
            locationSelected: null,
            defaultLocationSearchResults: [
                {
                    id: '0',
                    mainText: 'Makati, NCR',
                    type: 'LOCATION'
                },
                {
                    id: '1',
                    mainText: 'Manila, NCR',
                    type: 'LOCATION'
                },
                {
                    id: '2',
                    mainText: 'Quezon City, NCR',
                    type: 'LOCATION'
                },
                {
                    id: '3',
                    mainText: 'Valenzuela, NCR',
                    type: 'LOCATION'
                }
            ]
        }
    },
    computed: {
        gps_reverse: {
            get() {
                return this.$store.state.gps_reverse
            }
        },
        place_search_suggestion_list: {
            get() {
                if (this.placeQuery == '') {
                    return this.defaultPlaceSearchResults
                } else {
                    return this.$store.state.place_search_suggestion_list
                }
            }
        },
        location_search_suggestion_list: {
            get() {
                if (this.locationQuery == '') {
                    return this.defaultLocationSearchResults
                } else {
                    return this.$store.state.location_search_suggestion_list
                }
            }
        },
        search_result_retrieving: {
            get() {
                return this.$store.state.search_result_retrieving
            }
        }
    },
    watch: {
        gps_reverse(newValue) {
            console.log('changed in gps_reverse', newValue)
            // check if empty object / clear
            if (_.isEmpty(newValue)) {
                // do nothing
                console.log('empty gps_reverse')
            } else {
                // not empty
                console.log('not empty gps_reverse')
                // if empty, then use current user's location
                if (this.locationQuery == '') {
                    this.locationQuery = newValue.display
                }
            }
        }
    },
    methods: {
        lookupPlaceQuery: _.debounce(function(){
            console.log('debounced..')
            var payload = {
                text: this.placeQuery,
                location: this.locationQuery
            }
            this.$store.dispatch('retrievePlaceSuggestions', payload)
        }, 1),
        lookupLocationQuery: _.debounce(function(){
            console.log('debounced..')
            this.$store.dispatch('retrieveLocationSuggestions', this.locationQuery)
        }, 1),
        onLocationSelected(value) {
            console.log('locationSelected, resubmitting place query',value)
            // resubmit place queries
            this.lookupPlaceQuery()
            this.locationSelected = value
            this.searchNavigateAway()
        },
        onPlaceSelected(value) {
            console.log('placeSelected', value)
            this.placeSelected = value
            this.searchNavigateAway()
        },
        searchClicked() {
            console.log('searchClicked')
            this.$store.dispatch('setSearchResultRetrieving', true)
            this.$store.dispatch('resetSearchPlaceCounters')
            this.searchNavigateAway()
        },
        searchNavigateAway() {
            console.log('locationQuery', this.locationQuery)
            console.log('placeQuery', this.placeQuery)
            if (this.locationQuery == '') {
                console.log('location is required')
            }
            else if (this.placeQuery == '') {
                console.log('empty place... will return recommended places')
            } else if (this.placeQuery != '') {
                console.log('has placeQuery')
                this.loading = true
                if (this.placeSelected == null) {
                    console.log('placeSelected is null, return recommended results based on query')
                    // if reloadPage is true then reload
                    if (this.reloadPage == true) {
                        window.location.href = '/search?text=' + this.placeQuery + '&location=' + this.locationQuery
                    } else {
                        // change url query params
                        this.searchNavigateAway2()
                    }
                } else {
                    console.log('placeSelected is not null, return place info')
                    if (this.placeSelected.type == 'NAME') {
                        if (this.reloadPage == true) {
                            window.location.href = '/place/' + this.placeSelected.id
                        } else {
                            this.$router.push({
                                name: 'Place',
                                params: {
                                    id: this.placeSelected.id
                                }
                            })
                        }
                    } else if (this.placeSelected.type == 'TAG') {
                        // go to search
                        if (this.reloadPage == true) {
                            window.location.href = '/search?text=' + this.placeQuery + '&location=' + this.locationQuery
                        } else {
                            this.searchNavigateAway2()
                        }
                    } else {
                        console.error('not supported')
                    }
                    
                    // var vm = this
                    // setTimeout(() => {
                    //     vm.$router.push({
                    //         name: 'Place',
                    //         params: {
                    //             id: vm.placeSelected.id
                    //         }
                    //     })
                    // }, 1000);
                    
                }
            }
        },
        searchNavigateAway2() {
            this.$router.push({
                name: 'Search',
                query: {
                    text: this.placeQuery,
                    location: this.locationQuery
                }
            })
            history.pushState(
                {},
                null,
                '/search?text=' + this.placeQuery + '&location=' + this.locationQuery
            )
            var payload2 = {
                text: this.placeQuery,
                location: this.locationQuery
            }
            this.$store.dispatch('retrievePlacesSearch', payload2)
        }
    },
    mounted() {
        console.log('mounted from SearchInputGroup')

        // check if there is query params
        if (!_.isEmpty(this.$route.query)) {
            if (this.$route.query.text != '' && this.$route.query.location != '') {
                // set the location and place query equal to route query params
                this.placeQuery = this.$route.query.text
                this.locationQuery = this.$route.query.location
            }
        }

        this.$root.$on('validGPS', () => {
            console.log('received validGPS event from Imagery')
            // get reverse geocoded to determine the current city location
            this.$store.dispatch('retrieveGPSReverse')
        })
        this.$root.$on('invalidGPS', () => {
            console.log('received invalidGPS event from Imagery')
            //this.$store.dispatch('clearGPSReverse')
            console.log('FALLBACK ** trying to get gps using ip address')
            this.$store.dispatch('retrieveGPSusingIP')
        })
    }
}
</script>